<template>
  <div class="p-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Car (new)</h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <form>
          <div class="row">
            <div class="col-lg-7 col-md-7 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="mainCarDescription"
                  placeholder=" "
                  autocomplete="off_mainCarDescription"
                  v-model="userData.mainCarDescription"
                />
                <label class="floatingLabel" for="mainCarDescription"
                  >Description</label
                >
                <div class="invalid-feedback" v-if="errors.mainCarDescription">
                  {{ errors.mainCarDescription[0] }}
                </div>
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="secondaryCarDescription"
                  placeholder=" "
                  autocomplete="off_secondaryCarDescription"
                  v-model="userData.secondaryCarDescription"
                />
                <label class="floatingLabel" for="secondaryCarDescription"
                  >Sec. Description</label
                >
              </div>

              <div class="form-group">
                <b-form-select
                  plain
                  :options="getCarCategoryDropdown"
                  value-field="id"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_category"
                  v-model="userData.carCategoryId"
                ></b-form-select>
                <label class="floatingLabel" for="role">Category</label>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="vehicleWarranty"
                      placeholder=" "
                      autocomplete="off_vehicleWarranty"
                      v-model="userData.vehicleWarranty"
                    />
                    <label class="floatingLabel" for="vehicleWarranty"
                      >Vehicle Warranty</label
                    >
                    <div class="invalid-feedback" v-if="errors.vehicleWarranty">
                      {{ errors.vehicleWarranty[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="batteryWarranty"
                      placeholder=" "
                      autocomplete="off_batteryWarranty"
                      v-model="userData.batteryWarranty"
                    />
                    <label class="floatingLabel" for="batteryWarranty"
                      >Battery Warranty</label
                    >
                    <div class="invalid-feedback" v-if="errors.batteryWarranty">
                      {{ errors.batteryWarranty[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="weeklyCost"
                      placeholder=" "
                      autocomplete="off_weeklyCost"
                      v-model="userData.weeklyCost"
                    />
                    <label class="floatingLabel" for="weeklyCost"
                      >Weekly Cost</label
                    >
                    <div class="invalid-feedback" v-if="errors.weeklyCost">
                      {{ errors.weeklyCost[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="driveAwayPrice"
                      placeholder=" "
                      autocomplete="off_driveAwayPrice"
                      v-model="userData.driveAwayPrice"
                    />
                    <label class="floatingLabel" for="driveAwayPrice"
                      >Drive Away Price</label
                    >
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="rangeFrom"
                      placeholder=" "
                      autocomplete="off_rangeFrom"
                      v-model="userData.rangeFrom"
                    />
                    <label class="floatingLabel" for="rangeFrom"
                      >Range From</label
                    >
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="powerKW"
                      placeholder=" "
                      autocomplete="off_powerKW"
                      v-model="userData.powerKW"
                    />
                    <label class="floatingLabel" for="powerKW"
                      >Power (KW)</label
                    >
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="ANCAPSafetyRating"
                      placeholder=" "
                      autocomplete="off_ANCAPSafetyRating"
                      v-model="userData.ANCAPSafetyRating"
                    />
                    <label class="floatingLabel" for="ANCAPSafetyRating"
                      >ANCAP Safety Rating</label
                    >
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="performance"
                      placeholder=" "
                      autocomplete="off_performance"
                      v-model="userData.performance"
                    />
                    <label class="floatingLabel" for="performance"
                      >Performance</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-12">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="website"
                  placeholder=" "
                  autocomplete="off_website"
                  v-model="userData.website"
                />
                <label class="floatingLabel" for="website">Website</label>
              </div>

              <div class="row">
                <div class="col-lg-6 col-12">
                  <div class="form-group mt-3">
                    <label for="imageUpload">Featured image upload</label>
                    <div class="avatar-upload">
                      <div class="avatar-edit">
                        <input
                          ref="featuredImageUpload"
                          type="file"
                          id="featuredImageUpload"
                          accept=".png, .jpg, .jpeg"
                          @change="onFeaturedImageSelected($event)"
                        />
                        <label for="featuredImageUpload"></label>
                      </div>
                      <div class="avatar-preview">
                        <div
                          v-if="userData.featuredImage"
                          id="featuredImagePreview"
                          v-bind:style="{
                            backgroundImage:
                              'url(' + userData.featuredImage + ')'
                          }"
                        ></div>
                        <div v-else id="featuredImagePreview">
                          <i class="las la-image fs-12000 text-primary"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group mt-3">
                    <label for="imageUpload"
                      >Call to actionImage image upload</label
                    >
                    <div class="avatar-upload">
                      <div class="avatar-edit">
                        <input
                          ref="callToActionImageUpload"
                          type="file"
                          id="callToActionImageUpload"
                          accept=".png, .jpg, .jpeg"
                          @change="onCallToActionImageSelected($event)"
                        />
                        <label for="callToActionImageUpload"></label>
                      </div>
                      <div class="avatar-preview">
                        <div
                          v-if="userData.callToActionImage"
                          id="callToActionImagePreview"
                          v-bind:style="{
                            backgroundImage:
                              'url(' + userData.callToActionImage + ')'
                          }"
                        ></div>
                        <div v-else id="callToActionImagePreview">
                          <i
                            class="las la-sticky-note fs-12000 text-primary"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="fnCancel()"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnCreateCar"
              class="btn btn-primary btn-sm"
            >
              <b-spinner small v-if="isSpinActive"></b-spinner>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as carsService from '../../../services/cars.service'
import * as messageService from '../../../services/message.service'
import wdAvatarPreview from '../../../components/wd/WDAvatarPreview.vue'

export default {
  name: 'carNew',
  components: { wdAvatarPreview },

  data: function () {
    return {
      userData: {
        title: '',
        mainCarDescription: '',
        secondaryCarDescription: '',
        carCategoryId: '',
        vehicleWarranty: '',
        batteryWarranty: '',
        weeklyCost: '',
        driveAwayPrice: '',
        rangeFrom: '',
        powerKW: '',
        ANCAPSafetyRating: '',
        performance: '',
        website: '',
        featuredImage: '',
        callToActionImage: '',
        status: ''
      },
      isSpinActive: false,
      errors: '',
      selectedFeaturedImage: '',
      selectedCallToActionImage: '',
      carCategoryOptions: [],
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        ['blockquote', 'code-block'],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ]
    }
  },

  computed: {
    ...mapGetters(['getCarCategoryDropdown'])
  },

  methods: {
    ...mapActions(['fetchCarCategoryDropdown']),

    onFeaturedImageSelected(event) {
      const selectedFeaturedImage = event.target.files
      this.selectedFeaturedImage = event.target.files[0]
      if (!selectedFeaturedImage.length) return

      const reader = new FileReader()
      reader.readAsDataURL(selectedFeaturedImage[0])
      reader.onload = () => (this.userData.featuredImage = reader.result)
    },
    onCallToActionImageSelected(event) {
      const selectedCallToActionImage = event.target.files
      this.selectedCallToActionImage = event.target.files[0]
      if (!selectedCallToActionImage.length) return

      const reader = new FileReader()
      reader.readAsDataURL(selectedCallToActionImage[0])
      reader.onload = () => (this.userData.callToActionImage = reader.result)
    },
    fnCancel() {
      this.$router.push({ name: 'admin.cars' })
    },
    fnCreateCar: async function () {
      let formData = new FormData()
      formData.append('title', this.userData.title)
      formData.append('mainCarDescription', this.userData.mainCarDescription)
      formData.append(
        'secondaryCarDescription',
        this.userData.secondaryCarDescription
      )
      formData.append('carCategoryId', this.userData.carCategoryId)
      formData.append('vehicleWarranty', this.userData.vehicleWarranty)
      formData.append('batteryWarranty', this.userData.batteryWarranty)
      formData.append('weeklyCost', this.userData.weeklyCost)
      formData.append('driveAwayPrice', this.userData.driveAwayPrice)
      formData.append('rangeFrom', this.userData.rangeFrom)
      formData.append('powerKW', this.userData.powerKW)
      formData.append('ANCAPSafetyRating', this.userData.ANCAPSafetyRating)
      formData.append('performance', this.userData.performance)
      formData.append('website', this.userData.website)
      formData.append('featuredImageFile', this.selectedFeaturedImage)
      formData.append('callToActionImageFile', this.selectedCallToActionImage)

      try {
        const response = await carsService.add(formData)
        messageService.fnSweetAlertSuccessToast(
          'Car details',
          'save successfully'
        )

        this.$router.push({ name: 'admin.cars' })
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Save Car details',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Save Car details',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Save Car details',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Save Car details',
              'Something wrong, please try again!'
            )
            break
        }
        console.log('fnCreateNew - Something wrong, please try again!', error)
      }
    }
  },
  created() {
    this.fetchCarCategoryDropdown()
  }
}
</script>